module.exports = __webpack_public_path__ + "static/media/Compose.64c5b107.png";